import React from 'react'
import './Hero.css'
// import dark_arrow from '../../assets/images/icons8-arrow-24.png'

const Hero = () => {
  return (
    <div className='hero'>
        <div className='hero-text'>
            <p>41 YEARS OF EXCELLENCE</p>
            <h1>TRANSFORM YOURSELF</h1>
            
        </div>

    </div>
  )
}

export default Hero